import { render, staticRenderFns } from "./SupplierSupportCenter.vue?vue&type=template&id=495aa773&scoped=true&"
import script from "./SupplierSupportCenter.vue?vue&type=script&lang=js&"
export * from "./SupplierSupportCenter.vue?vue&type=script&lang=js&"
import style0 from "./SupplierSupportCenter.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SupplierSupportCenter.vue?vue&type=style&index=1&id=495aa773&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495aa773",
  null
  
)

export default component.exports